<article class="nw-tooltip">
    @if (type === 'link') {
        <a nw-link [nwMenuTriggerFor]="menu">{{ linkLabel }} </a>
    } @else {
        <button
            nw-icon-button
            [nwMenuTriggerFor]="menu"
            size="m"
            aria-label="Information"
            type="button"
        >
            <nw-icon [icon]="icon" class="nw-tooltip__icon"></nw-icon>
        </button>
    }
</article>

<nw-menu #menu="nwMenu" [class]="class" [xPosition]="xPosition" [yPosition]="yPosition">
    <ng-content></ng-content>
    <div [innerHTML]="content"></div>
</nw-menu>
